import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React from 'react'
import MainLayout from '../Layouts/Index'
import Seo from '../Utils/Seo'
import SraTechApproval from '../Components/SraTechApproval'
import ScnTechApproval from '../Components/ScnTechApproval'
import RequestTechApproval from '../Components/RequestTechApproval'
import TransferTechApproval from '../Components/TransferTechApproval'

export default function TechApproval() {
    return (
        <MainLayout>
            <Seo title='Approval' description='EKO Approval IMS' />

            <Tabs variant='enclosed'>
                <TabList>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>SRA</Tab>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>SCN</Tab>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>Request</Tab>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>Transfer</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                       <SraTechApproval/>
                    </TabPanel>
                    <TabPanel>
                       <ScnTechApproval/>
                    </TabPanel>
                    <TabPanel>
                       <RequestTechApproval/>
                    </TabPanel>
                    <TabPanel>
                       <TransferTechApproval/>
                    </TabPanel>
                  
                </TabPanels>
            </Tabs>

        </MainLayout>
    )
}

